import React, { FC, useState } from 'react';
import { useRouter } from 'next/navigation';
import dynamic from 'next/dynamic';
import { AmplienceHeaderNavProps } from 'components/amplience/header-nav';
import { AmplienceMegaNavProps } from 'components/amplience/header-nav/components/mega-nav';
import AmplienceMegaNavMobile from 'components/amplience/header-nav/components/mega-nav/mega-nav-mobile';
import AmplienceHeaderNavMobile from 'components/amplience/header-nav/header-nav-mobile';
import { MobileMenuContext } from '../../context/mobile-menu-context';
import { Button } from 'components/ui/button';
import { useAccount } from 'frontastic';

const AccountButton = dynamic(() => import('../../../utility-section/account-button'));

interface Props {
  headerNav: AmplienceHeaderNavProps;
}

const MobileMenu: FC<Props> = ({ headerNav }) => {
  const [megaNavSelected, setMegaNavSelected] = useState<AmplienceMegaNavProps | undefined>();

  const onClickMegaNav = (megaNav: AmplienceMegaNavProps | undefined) => {
    setMegaNavSelected(megaNav);
  };
  const { logout, account } = useAccount();
  const router = useRouter();

  return (
    <MobileMenuContext.Provider value={{ megaNavSelected, setMegaNavSelected: onClickMegaNav }}>
      {!megaNavSelected ? (
        <div>
          <div className="flex h-[54px] w-full items-center justify-between border border-black/10 bg-primary-cream px-4">
            <AccountButton />
            {account && (
              <Button
                onClick={() => {
                  logout();
                  router.push('/login');
                }}
                className="text-sm font-semibold underline"
              >
                Sign Out
              </Button>
            )}
          </div>
          <AmplienceHeaderNavMobile megaNavs={headerNav?.megaNavs} />
        </div>
      ) : (
        <AmplienceMegaNavMobile {...megaNavSelected} />
      )}
    </MobileMenuContext.Provider>
  );
};

export default MobileMenu;
